import { Form, Input, Select } from 'antd';
import { ToggleHeader, ToggleSwitch } from '@/components/toggle-switch';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** Platform modules and sign-in (MFA / SSO) settings. */
export default function CompanyModulesAccessSettings() {
  const {
    activityFeedEnabledKeys,
    activityFeedEnabledState,
    assistantEnabledKeys,
    assistantEnabledState,
    calculatorEnabledKeys,
    calculatorEnabledState,
    form,
    isProfile,
    mfaEnabledKeys,
    mfaEnabledState,
    sectionClass,
    ssoAllowedDomainsKeys,
    ssoAllowedDomainsState,
    ssoOnlyKeys,
    ssoOnlyState,
    ssoTenantIdKeys,
    ssoTenantIdState,
    t,
    toolsEnabledKeys,
    toolsEnabledState,
  } = useCompanyGeneralDataForm();
  // On the profile: laid out by CompanyModulesAccessProfilePanel.
  if (isProfile) return null;

  return (
    <>
      {(toolsEnabledState?.visible ||
        calculatorEnabledState?.visible ||
        assistantEnabledState?.visible) && (
        <div className={sectionClass('moduli')}>
          {!isProfile && <hr className="my-5" />}

          <p className="mb-3 text-xs font-medium uppercase text-gray-400">
            {t('moduleVisibility', { ns: 'forms' })}
          </p>

          <div className="rounded-md border bg-white p-4">
            {toolsEnabledState?.visible && (
              <ToggleHeader
                title={t('toolsModuleEnabled', { ns: 'forms' })}
                className={
                  calculatorEnabledState?.visible ||
                  assistantEnabledState?.visible
                    ? 'mb-5'
                    : ''
                }
              >
                <ToggleSwitch
                  name={toolsEnabledKeys}
                  form={form}
                  disabled={toolsEnabledState?.disabled}
                />
              </ToggleHeader>
            )}

            {calculatorEnabledState?.visible && (
              <ToggleHeader
                title={t('calculatorModuleEnabled', { ns: 'forms' })}
                className={assistantEnabledState?.visible ? 'mb-5' : ''}
              >
                <ToggleSwitch
                  name={calculatorEnabledKeys}
                  form={form}
                  disabled={calculatorEnabledState?.disabled}
                />
              </ToggleHeader>
            )}

            {assistantEnabledState?.visible && (
              <ToggleHeader
                title={t('assistantModuleEnabled', { ns: 'forms' })}
                className={activityFeedEnabledState?.visible ? 'mb-5' : ''}
              >
                <ToggleSwitch
                  name={assistantEnabledKeys}
                  form={form}
                  disabled={assistantEnabledState?.disabled}
                />
              </ToggleHeader>
            )}

            {activityFeedEnabledState?.visible && (
              <ToggleHeader title={t('activityFeedEnabled', { ns: 'forms' })}>
                <ToggleSwitch
                  name={activityFeedEnabledKeys}
                  form={form}
                  disabled={activityFeedEnabledState?.disabled}
                />
              </ToggleHeader>
            )}
          </div>
        </div>
      )}

      {(mfaEnabledState?.visible || ssoOnlyState?.visible) && (
        <div className={sectionClass('pristup')}>
          {!isProfile && <hr className="my-5" />}

          <p className="mb-3 text-xs font-medium uppercase text-gray-400">
            {t('security', { ns: 'forms' })}
          </p>

          {mfaEnabledState?.visible && (
            <div className="rounded-md border bg-white p-4">
              <ToggleHeader
                title={t('mfaEnabledCompanyLabel', { ns: 'forms' })}
              >
                <ToggleSwitch
                  name={mfaEnabledKeys}
                  form={form}
                  disabled={mfaEnabledState?.disabled}
                />
              </ToggleHeader>
            </div>
          )}

          {ssoOnlyState?.visible && (
            <div className="mt-3 rounded-md border bg-white p-4">
              <ToggleHeader title={t('ssoOnlyLabel', { ns: 'forms' })}>
                <ToggleSwitch
                  name={ssoOnlyKeys}
                  form={form}
                  disabled={ssoOnlyState?.disabled}
                />
              </ToggleHeader>

              <p className="mt-2 text-xs text-gray-400">
                {t('ssoOnlyHint', { ns: 'forms' })}
              </p>
            </div>
          )}

          {ssoTenantIdState?.visible && (
            <Form.Item
              className="mt-3"
              name={ssoTenantIdKeys}
              label={t('ssoTenantId', { ns: 'forms' })}
              tooltip={t('ssoTenantIdHint', { ns: 'forms' })}
            >
              <Input
                placeholder={t('ssoTenantId', { ns: 'forms' })}
                disabled={ssoTenantIdState?.disabled}
              />
            </Form.Item>
          )}

          {ssoAllowedDomainsState?.visible && (
            <Form.Item
              name={ssoAllowedDomainsKeys}
              label={t('ssoAllowedDomains', { ns: 'forms' })}
              tooltip={t('ssoAllowedDomainsHint', { ns: 'forms' })}
            >
              <Select
                mode="tags"
                open={false}
                tokenSeparators={[',', ' ']}
                placeholder={t('ssoAllowedDomains', { ns: 'forms' })}
                disabled={ssoAllowedDomainsState?.disabled}
              />
            </Form.Item>
          )}
        </div>
      )}
    </>
  );
}
